import { render, staticRenderFns } from "./ActivitySpeechBubbles.vue?vue&type=template&id=61b99982"
import script from "./ActivitySpeechBubbles.vue?vue&type=script&lang=ts"
export * from "./ActivitySpeechBubbles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ActivitySpeechBubbles.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports